<i [class]="value() ? onIcon() : offIcon()" (click)="onClick()"></i>
